import { render, staticRenderFns } from "./journal-message.component.vue?vue&type=template&id=12fab514&"
import script from "./journal-message.component.vue?vue&type=script&lang=js&"
export * from "./journal-message.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports